

export interface ColorTheme {
  name: string;
  rootColor: string;
  textColor: string;
  colors: string[];
}

export const colorThemes: ColorTheme[] = [
  {
    name: '鲜艳',
    rootColor: '#34495E',
    textColor: '#fff',
    colors: [
      "#3498DB",  
      "#2ECC71",
      "#F1C40F",  // 明亮黄色，活泼温暖，带来活力氛围
      "#E74C3C",  // 鲜明红色，醒目有力，增添视觉冲击
      "#9B59B6",  // 神秘紫色，优雅浪漫，富有艺术气息
      "#1ABC9C",  // 清新青绿色，宁静自然，令人放松
      "#F39C12",  // 橙黄色，热情温暖，充满活力
      "#7F8C8D",  // 淡灰色，简约平和，营造宁静氛围
      "#FF7F50"   // 珊瑚红色，柔和醒目，带来愉悦感受
    ],
  },
  {
    name: '暗黑色',
    rootColor: '#1F1F1F',
    textColor: '#fff',
    colors: [
      "#283593",  // 深邃的蓝色调，像深夜的海洋，神秘且稳重
      "#4A148C",  // 浓郁的紫色，富有高贵神秘的气质
      "#3E2723",  // 深棕褐色，类似古老的皮革，散发着复古气息
      "#1B5E20",  // 深绿色，如同茂密森林的深处，充满生机又沉稳
      "#880E4F",  // 暗玫红色，带着一丝冷艳与神秘
      "#263238",  // 深灰色调，简洁而有质感，低调沉稳
      "#607D8B",  // 蓝灰色，给人宁静、深邃的感觉
      "#455A64",  // 偏蓝的深灰色，营造出冷静、理智的氛围
      "#795548",  // 深驼色，温暖而不失深沉，具有独特韵味
      "#5D4037"   // 深土黄色，质朴自然，为暗色系增添别样色彩
    ]
  },
  {
    name: '马卡龙',
    rootColor: '#FFB6C1',
    textColor: '#1f1f1f',
    colors: [
      "#FFE4B5", // 浅奶黄色，给人温暖、甜蜜的感觉，类似柠檬味马卡龙
      "#90EE90", // 清新的淡绿色，如抹茶味马卡龙，充满生机
      "#87CEEB", // 淡蓝色，仿佛天空的颜色，清爽宜人，类似蓝莓味马卡龙
      "#D8BFD8", // 浅紫色，优雅梦幻，如同葡萄味马卡龙
      "#FFDAB9", // 桃红色，活泼甜美，像水蜜桃味马卡龙
      "#F0E68C", // 明亮的淡黄色，充满活力，类似香蕉味马卡龙
      "#E0FFFF", // 淡青色，清爽宁静，仿佛青柠味马卡龙
      "#FAEBD7", // 米白色，柔和舒适，类似香草味马卡龙
    ]
  },
];
